var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row header"},_vm._l((_vm.columns),function(column){return _c('div',{key:column.id,staticClass:"cell",style:({ 'flex-grow': column.width })},[_vm._v(" "+_vm._s(column.label)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }